let slideIndex = 1;

showSlides(slideIndex);

function plusSlides(n) {

  showSlides(slideIndex += n);
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("mySlides");
    let slideItems = document.getElementsByClassName("slide-item");

    if (n > slides.length) {
      slideIndex = 1
    }  

    if (n < 1) {
      slideIndex = slides.length
    }

    for (i = 0; i < slides.length; i++) {
      slides[i].className = slides[i].className.replace(" is-active", "");
    }

    for (i = 0; i < slideItems.length; i++) {
      slideItems[i].className = slideItems[i].className.replace(" is-active", "");
    }

    slides[slideIndex-1].className += " is-active";  
    slideItems[slideIndex-1].className += " is-active";
}

var slideShow = document.querySelector(".slideshow-container") ?? document.querySelector('.main-img-container');

console.log(slideShow);

slideShow.addEventListener("touchstart", startTouch, false);
slideShow.addEventListener("touchmove", moveTouch, false);

  // Swipe Up / Down / Left / Right
  var initialX = null;
  var initialY = null;

  function startTouch(e) {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  };

  function moveTouch(e) {
    if (initialX === null) {
      return;
    }

    if (initialY === null) {
      return;
    }

    var currentX = e.touches[0].clientX;
    var currentY = e.touches[0].clientY;

    var diffX = initialX - currentX;
    var diffY = initialY - currentY;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      // sliding horizontally
      if (diffX > 0) {
        // swiped left
        plusSlides(1);
      } else {
        // swiped right
        plusSlides(-1);
      }  
    }

    initialX = null;
    initialY = null;

    e.preventDefault();
  };
